import { render, staticRenderFns } from "./serial_code_dialog.vue?vue&type=template&id=f665b6fe"
import script from "./serial_code_dialog.vue?vue&type=script&lang=ts"
export * from "./serial_code_dialog.vue?vue&type=script&lang=ts"
import style0 from "./serial_code_dialog.vue?vue&type=style&index=0&id=f665b6fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports